import api from "@/lib/api";

/**
 * Canonical fallback plan catalogue — used when the API is slow, unreachable,
 * or returns empty. Values must mirror the backend seeded plans so that pricing
 * shown to the user always matches what they are later charged.
 */
export const FALLBACK_PLANS = [
  {
    plan_id: "fallback-individual",
    name: "Individual",
    tier: "individual",
    price: 2000,
    base_price: 1694.92,
    gst_percent: 18,
    duration_months: 12,
    family_members: 1,
    tagline: "For one. Built for everyday wellness.",
    benefits: [
      "Unlimited OPD consultations",
      "20% off on Lab tests",
      "20% off on Radiology",
      "5% off on Pharmacy",
      "5% off on Hospital billing",
      "Basic Health Checkup included",
    ],
    is_active: true,
    highlight: false,
  },
  {
    plan_id: "fallback-husband-wife",
    name: "Husband Wife",
    tier: "husband_wife",
    price: 3000,
    base_price: 2542.37,
    gst_percent: 18,
    duration_months: 12,
    family_members: 2,
    tagline: "For couples — shared wellness.",
    benefits: [
      "Unlimited OPD consultations",
      "25% off on Lab tests",
      "25% off on Radiology",
      "10% off on Pharmacy",
      "10% off on Hospital billing",
      "Basic Health Checkup for both",
    ],
    is_active: true,
    highlight: true,
  },
  {
    plan_id: "fallback-family",
    name: "Family",
    tier: "family",
    price: 6000,
    base_price: 5084.75,
    gst_percent: 18,
    duration_months: 12,
    family_members: 6,
    tagline: "Up to 6 members. Husband + Wife + Children <18 + Parents.",
    benefits: [
      "Unlimited OPD consultations",
      "30% off on Lab tests",
      "30% off on Radiology",
      "15% off on Pharmacy",
      "15% off on Hospital billing",
      "Basic Health Checkup for all",
    ],
    is_active: true,
    highlight: false,
  },
];

/**
 * Fetch active plans from the API. Guarantees a non-empty array:
 * - API returns 3 active plans → use them
 * - API returns empty / errors / times out → FALLBACK_PLANS
 */
export async function fetchPlans() {
  try {
    const r = await api.get("/plans", { timeout: 8000 });
    const active = (r.data || []).filter((p) => p.is_active !== false);
    return active.length ? active : FALLBACK_PLANS;
  } catch (_e) {
    return FALLBACK_PLANS;
  }
}
